import { render, staticRenderFns } from "./PreviewPackage.vue?vue&type=template&id=0970ab47&scoped=true"
import script from "./PreviewPackage.vue?vue&type=script&lang=js"
export * from "./PreviewPackage.vue?vue&type=script&lang=js"
import style0 from "./PreviewPackage.vue?vue&type=style&index=0&id=0970ab47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0970ab47",
  null
  
)

export default component.exports